{
  "title": "Mental Barrier (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 reaction, which you take when you are forced to make an Intelligence, a Wisdom, or a Charisma saving throw",
  "range": "Self",
  "components": "V",
  "duration": "1 round",
  "description": [
    "You protect your mind with a wall of looping, repetitive thought. Until the start of your next turn, you have advantage on Intelligence, Wisdom, and Charisma saving throws, and you have resistance to psychic damage."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
